import React from 'react';
import Link from 'components/link';
import Html from 'components/html';
import uri from 'utils/uri';
import type { StyledElement, TestAutomation } from 'contracts';

interface LinkifyTextElement extends StyledElement, TestAutomation {
  text: string | undefined | null;
}

const LinkifyText: React.FunctionComponent<LinkifyTextElement> = (props) => {
  const { text, testId, className, ...rest } = props;

  if (!text) return null;

  return (
    <Html.div testId={testId} className={className} typography="caption" arias={rest}>
      {uri.linkfy(text, (url: string) => (
        <Link key={url} href={url} target="_blank">
          {url}
        </Link>
      ))}
    </Html.div>
  );
};

export type { LinkifyTextElement };
export default React.memo(LinkifyText, (prev, next) => {
  return prev.text === next.text;
});
